import { AiRunnerOption, AiRunnerOptionValues } from './ai-runner.model';

/**
 * Lembra no navegador as opções marcadas com `remember` (uma entrada por `storageKey`). Tudo em
 * try/catch: em janela anônima, com armazenamento bloqueado ou cheio, o modal só usa os padrões.
 */
const PREFIX = 'ai-runner:';

export function loadRememberedOptions(storageKey: string | undefined): Record<string, unknown> {
  if (!storageKey) return {};
  try {
    const raw = localStorage.getItem(PREFIX + storageKey);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function saveRememberedOptions(
  storageKey: string | undefined,
  options: readonly AiRunnerOption[],
  values: AiRunnerOptionValues
): void {
  if (!storageKey) return;
  const remembered = options.filter(option => option.remember);
  if (!remembered.length) return;
  try {
    const current = loadRememberedOptions(storageKey);
    for (const option of remembered) current[option.key] = values[option.key] ?? null;
    localStorage.setItem(PREFIX + storageKey, JSON.stringify(current));
  } catch {
    // sem armazenamento: segue sem lembrar
  }
}
